import { render, staticRenderFns } from "./StuNumStatisticsWomen.vue?vue&type=template&id=8296b6ca&scoped=true&"
import script from "./StuNumStatisticsWomen.vue?vue&type=script&lang=js&"
export * from "./StuNumStatisticsWomen.vue?vue&type=script&lang=js&"
import style0 from "./StuNumStatisticsWomen.vue?vue&type=style&index=0&id=8296b6ca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8296b6ca",
  null
  
)

export default component.exports